// Normalize maplibre-gl module shape across bundlers (dev/prod, CJS/ESM interop).
function extractMaplibre(candidate) {
    if (!candidate) return null;
    const shapes = [
        candidate,
        candidate.default,
        candidate.default && candidate.default.default,
        candidate.maplibregl,
        candidate.default && candidate.default.maplibregl,
    ];
    for (let i = 0; i < shapes.length; i += 1) {
        const lib = shapes[i];
        if (lib && typeof lib.Map === 'function') {
            return lib;
        }
    }
    return null;
}

function waitForGlobalMaplibre(timeoutMs = 10000) {
    if (typeof window === 'undefined') return Promise.resolve(null);
    if (window.maplibregl && typeof window.maplibregl.Map === 'function') {
        return Promise.resolve(window.maplibregl);
    }
    return new Promise((resolve) => {
        const start = Date.now();
        const tick = () => {
            if (window.maplibregl && typeof window.maplibregl.Map === 'function') {
                resolve(window.maplibregl);
                return;
            }
            if (Date.now() - start >= timeoutMs) {
                resolve(null);
                return;
            }
            setTimeout(tick, 50);
        };
        tick();
    });
}

const maplibreLib = (async () => {
    // Prefer the global bundle loaded via <script> tag in public/index.html.
    // It is the original UMD distribution and avoids webpack/terser re-processing
    // (which has caused worker errors like `g is not defined` in production).
    const fromGlobal = await waitForGlobalMaplibre(10000);
    if (fromGlobal) return fromGlobal;

    // Fallback: dynamic import via bundler if the CDN script failed to load.
    const loaders = [
        () => import('maplibre-gl'),
        () => import('maplibre-gl/dist/maplibre-gl.js'),
    ];

    for (let i = 0; i < loaders.length; i += 1) {
        try {
            const mod = await loaders[i]();
            const lib = extractMaplibre(mod);
            if (lib) return lib;
        } catch (e) {
            // Try next fallback.
        }
    }

    throw new Error('Failed to load maplibre-gl (Map constructor not found)');
})();

export { maplibreLib };
